import { defineMessages } from 'react-intl';

export const trelloWorkspaceSelectorMessages = defineMessages({
  siteLabel: {
    id: 'mcp.trelloWorkspaceSelector.siteLabel',
    defaultMessage: 'Authorize access for:',
    description:
      'Label above the Trello workspace selector when it is the only selector visible',
  },
  placeholder: {
    id: 'mcp.trelloWorkspaceSelector.placeholder',
    defaultMessage: 'Select a Trello workspace',
    description: 'Placeholder text for the Trello workspace selector',
  },
  multiSelectLabel: {
    id: 'mcp.trelloWorkspaceSelector.multiSelectLabel',
    defaultMessage: 'Trello workspaces',
    description: 'Field label shown above the Trello multi-workspace selector',
  },
  recentGroupLabel: {
    id: 'mcp.trelloWorkspaceSelector.recentGroupLabel',
    defaultMessage: 'Recently used',
    description: 'Group label for Trello workspaces the user has used recently',
  },
  allGroupLabel: {
    id: 'mcp.trelloWorkspaceSelector.allGroupLabel',
    defaultMessage: 'All',
    description: 'Group label for all Trello workspaces the user can authorize',
  },
  mixedDescription: {
    id: 'mcp.trelloWorkspaceSelector.mixedDescription',
    defaultMessage:
      'A Trello workspace is also needed to allow access to your Trello boards and cards.',
    description:
      'Help text shown below the Trello workspace selector when both Atlassian site and Trello workspace selectors are visible',
  },
  noWorkspacesHeading: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesHeading',
    defaultMessage: 'No Trello workspaces found',
    description: 'Heading for empty state when user has no Trello workspaces',
  },
  noWorkspacesDescription: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesDescription',
    defaultMessage:
      "You might be signed in with an account that doesn't have Trello access. Try {switchAccountLink} or {contactSupportLink}",
    description:
      'Description for empty state when no Trello workspaces available, includes switch account and contact support links',
  },
  noWorkspacesSwitchAccount: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesSwitchAccount',
    defaultMessage: 'signing in with a different account',
    description: 'Switch account link text in Trello no-workspaces empty state',
  },
  noWorkspacesContactSupport: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesContactSupport',
    defaultMessage: 'contact support',
    description:
      'Contact support link text in Trello no-workspaces empty state',
  },
  noWorkspaceAvailablePlaceholder: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspaceAvailablePlaceholder',
    defaultMessage: 'No workspace available',
    description:
      'Disabled selector placeholder when the user has no Trello workspaces but can still grant Inbox and Planner access',
  },
  selectionLimitHelpText: {
    id: 'mcp.trelloWorkspaceSelector.selectionLimitHelpText',
    defaultMessage:
      'You can choose up to {limit, plural, one {# workspace} other {# workspaces}} {clientName} can access',
    description:
      'Help text below the Trello multi-workspace selector telling the user how many workspaces the requesting client can be given access to',
  },
  selectionLimitHelpTextNoClient: {
    id: 'mcp.trelloWorkspaceSelector.selectionLimitHelpTextNoClient',
    defaultMessage:
      'You can choose up to {limit, plural, one {# workspace} other {# workspaces}}',
    description:
      'Help text below the Trello multi-workspace selector when the requesting client name is unknown',
  },
  enterpriseBadge: {
    id: 'mcp.trelloWorkspaceSelector.enterpriseBadge',
    defaultMessage: 'Enterprise',
    description:
      'Badge shown next to a Trello workspace that belongs to an Atlassian organization, indicating it can only be combined with workspaces from the same organization',
  },
  organizationFilterHelpText: {
    id: 'mcp.trelloWorkspaceSelector.organizationFilterHelpText',
    defaultMessage:
      'Only workspaces that can be selected alongside your first choice are shown. Clear your selection to see all workspaces.',
    description:
      'Help text shown below the Trello multi-workspace selector once a selection has narrowed the list. Workspaces can only be combined when they belong to the same organization, or when none of them belong to one.',
  },
  loadingMoreWorkspaces: {
    id: 'mcp.trelloWorkspaceSelector.loadingMoreWorkspaces',
    defaultMessage: 'Loading more workspaces\u2026',
    description:
      'Shown at the bottom of the Trello workspace dropdown while the next page of workspaces is being fetched',
  },
  noWorkspacesCompact: {
    id: 'mcp.trelloWorkspaceSelector.noWorkspacesCompact',
    defaultMessage:
      "No Trello workspaces found. You might be signed in with an account that doesn't have Trello access. Try {switchAccountLink} or {contactSupportLink}",
    description:
      'Compact message shown in the mixed flow when no Trello workspaces are available',
  },
});
